<script setup lang="ts">
import { useScreen } from "@/composable/useResponsive";
import LegendConfigurator from "@/components/legends/configurator/LegendConfigurator.vue";
import { useGetLegend, useUpdateLegend } from "@/stores/queries";
import type { UpdatePayload, WithoutID } from "@/types/generic.types";
import type { Legend } from "@/types/legend.types";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();

const route = useRoute();
const router = useRouter();

const id = computed(() =>
  route.params.id ? Number(route.params.id) : undefined
);

const { data: legend, isLoading } = useGetLegend(id);
const { mutateAsync: updateLegendMutation, isPending } = useUpdateLegend();

const backToLegends = () => {
  router.push({ name: "settings-legends" });
};

const handleUpdateLegend = (newLegend: WithoutID<Legend>) => {
  if (!legend.value) return;
  const payload: UpdatePayload<Legend> = {
    id: legend.value.id,
    ...newLegend,
  };
  updateLegendMutation(payload, {
    onSuccess: () => {
      backToLegends();
    },
  });
};

const { texts } = useScreen();

const saveBtnText = computed(() => {
  return {
    xs: t("dashboard:save"),
    md: t("dashboard:save.modifications"),
  };
});
</script>

<template>
  <div class="mb-5 mx-3 mx-md-4 mx-lg-5 px-sm-2 px-md-4 px-lg-5">
    <div v-if="isLoading" class="p-5">Chargement ...</div>
    <template v-else-if="legend">
      <LegendConfigurator
        :loading="isPending"
        :legend="legend"
        :legend-id="legend.id"
        :confirm-label="texts(saveBtnText)"
        @save="handleUpdateLegend"
        @back="backToLegends"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped></style>
